import type {
  AuthError as AuthErrorType,
  UserAttributes as UserAttributesType,
} from "@supabase/supabase-js";

export enum UserAudience {
  professionals = "professionals",
  consumers = "consumers",
}

export type UserAttributes = UserAttributesType;
export type AuthError = AuthErrorType;

export interface UserMetadata {
  profile_id?: string;
  enabledAudiences: UserAudience[];
  email: string;
  email_verified: boolean;
  sub: string;
  name?: string;
  surname?: string;
  audience: UserAudience;
  phone?: string;
  phone_verified?: boolean;
}
